import { render, staticRenderFns } from "./VerticalTable.vue?vue&type=template&id=556e37cf&scoped=true&"
import script from "./VerticalTable.vue?vue&type=script&lang=js&"
export * from "./VerticalTable.vue?vue&type=script&lang=js&"
import style0 from "./VerticalTable.vue?vue&type=style&index=0&id=556e37cf&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "556e37cf",
  null
  
)

export default component.exports